<script type="text/ecmascript-6">
    import DesignerQuestionDoorColourInternal from "../DesignerQuestionDoorColourInternal.vue";
    import TileQuestion from "../mixin/TileQuestion.vue";

    export default {
        mixins: [
            DesignerQuestionDoorColourInternal,
            TileQuestion
        ],
        watch: {
            'target': function (val, oldVal) {
                this.$dispatch('door-internal-colour-updated', val);
            }
        },
    }
</script>
